export function checkIfAlreadyFilled(ids, shopUserId) {
    if (shopUserId !== "") {
        $.ajax({
            type: "POST",
            url: "/module/community/ajax.php?action=check_if_already_filled",
            datatype: "json",
            data: {
                "ajax_call_ids": ids,
                "ajax_call_shop_user_id": shopUserId,
                "ajax_call_list_community_type": communityType
            },
            success: function (output) {
                var data = $.parseJSON(output);
                var filledIds = data.filled_ids;
                $.each(filledIds, function (key, value) {
                    if (parseInt(communityType) === 1) { // Timeline
                        $.each(data.timeline_elements, function (timelineKey, timelineValue) {
                            var surveyData = data.survey_answers[value.community_survey_id];
                            if (parseInt(timelineValue.id) === parseInt(timelineKey)) {
                                displaySurveyResult($("#" + timelineKey), surveyData, surveyData["posted_answers"]);
                            }

                        });
                    } else { // Umfragen-Übersicht
                        $.each(data.survey_answers, function (surveyKey, surveyValue) {
                            if (surveyValue[0] !== undefined && surveyValue[0].id === key) {
                                displaySurveyResult($("#" + key), surveyValue, surveyValue["posted_answers"]);
                            }
                        });
                    }
                });
            }
        });
    }
}